// extracted by mini-css-extract-plugin
module.exports = {"modal-style":"style_modal-style__19jr_","overlay-style":"style_overlay-style__qzVMG","content-error":"style_content-error__3UEeH","message":"style_message__yYg_B"};